import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_JOB_LIFTPLANS,
  LINK_LIFTPLAN_JOBS,
  UPDATE_LIFTPLAN,
} from '../../../graph-queries/tar/liftplan';
import { TLiftPlan } from '../../../lib/types';
import AspectsTable from '../AspectsTable/AspectsTable';
import LiftPlanForm from '../LiftplanForm/LiftplanForm2';
import classes from './JobAspects.module.scss';
import { columns } from '../../pages/Liftplans/Liftplans';
import { useParams } from 'react-router-dom';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobLiftPlan: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const { data, loading } = useQuery(GET_JOB_LIFTPLANS, {
    variables: { jobId },
  });
  const [updateLiftPlan] = useMutation(UPDATE_LIFTPLAN, {
    refetchQueries: [GET_JOB_LIFTPLANS],
  });
  const [linkLiftPlanJobs] = useMutation(LINK_LIFTPLAN_JOBS, {
    refetchQueries: [GET_JOB_LIFTPLANS],
  });

  const onEditSubmit = (liftPlan: TLiftPlan) => {
    const { updatedBy, updatedAt, tarJobs, ...input } = liftPlan;
    return updateLiftPlan({ variables: { input } });
  };

  const onLinkSubmit = (selection: TLiftPlan[], jobIds: number[]) => {
    return Promise.all(
      selection.map((liftPlan) =>
        linkLiftPlanJobs({
          variables: {
            liftPlanId: liftPlan.liftPlanId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TLiftPlan>
      aspectName="liftplan"
      data={(data?.liftPlansByJobId as unknown as TLiftPlan[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <LiftPlanForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>LiftPlan</div>}
    />
  );
};

export default JobLiftPlan;
